import "./Transparency.module.css";
import Header from "@/reusable_sections/Header";
import LetsSizzle from "./sections/LetsSizzle";
import PortalBenefits from "./sections/PortalBenefits";
import Footer from "@/reusable_sections/Footer";
export default function TransparencyPage() {
  return <div>
      <Header />
      <LetsSizzle />
      <PortalBenefits />
      <Footer />
    </div>;
}